<style>
.listUl{
    background-color: #E5E5E5;
}
.listUl li{
    height: 32px;
    text-align: center;
    border-bottom: 1px solid #fff;
    line-height: 32px;
    color: #000;
    font-size: 16px;
}
.listUl li i{
    font-size: 32px;
    position: absolute;
    right: 5px;
}
.listUl .active {
    background-color: #F2F2F2;
    color: #000;

}
/* .ivu-modal-content .ivu-modal-body{
    width: 375px;
    padding: 0;
    margin:0;
} */
</style>

<template>
<div>
    <Modal
        v-model="isShow"
        :z-index="2000"
        :fullscreen="full"
        :width="width"
        :footer-hide="footer"
        >
        <div v-show="isShow" :style="domStyle" class="styleApp">
            <div :style="domStyle">
                <div style="width:100%;height:5%;background:#D6D6D6;text-align: center;
                    color: #000;
                    font-size: 21px;">
                    <a style="position: absolute;left: 2%;color: #000;" @click="after">
                        <Icon type="ios-arrow-back" />
                    </a>
                    {{dataTitle}}
                    <a style="position: absolute;right: 2%;color: #000;" @click ="onClose">
                        <Icon type="md-close" />
                    </a> 
                </div>
                <div style="width:100%;height:95%;overflow: scroll;">
                    <ul class="listUl">
                        <li v-for="index in tagsTreeData" 
                            @click = onGetData(index,tagsTreeData)
                            :class="{'active':current == index}"
                        >
                            {{ index.title }}
                            <i v-if="index.children.length != 0" ><Icon type="md-return-right" /></i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Modal>
    
</div>
</template>

<script>
export default {
    name : "dataDialog",
    mounted : function(){
        this.$store.registerModule(['system','dataDialog'],{
            state : {
                $ : this
            }
        });
        this.domStyle = {
                position : "absolute",
                left : this.x + "px",
                top : this.y + "px",
                width : window.innerWidth + "px",
                height : window.innerHeight + "px",
                backgroundColor:"#FFF"
            };
        this.UpdataData();
    },
    data : function(){
        return {
            windowStyle:{
                top:0,
                left:0,
                margin : "0 0",
                padding : "0px"
            },
            width:"375px",
            height:"600px",
            dataTitle:"数据点",
             //存储点击过的父节点数据
            parentData:[],
            //渲染的节点
            current:"",
            //节点路径
            route:"",
            //是否可用
            isEnable : false,
            //是否显示
            isShow : false,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            historyFormHeight:"",
            tagsTreeData:[],//存储数据
            footer:true,
            full:true,
            getData:"",//返回点
            getDesc:""//返回点描述
        }
    },
    methods: {
        //点击列表，返回数据
        onGetData(data,data1){
            this.current = data;
            //如果点击到点,返回路径
            if(data.title.indexOf("PV")>-1){
                this.getData = this.route + data.title;
                this.getDesc = data.desc;
                return;
            }
            //存储点击后节点父节点数据
            this.parentData.push(data1);
            this.route += data.title+".";//存储路径
            var TreeData = [];
            if(data.children.length != 0){
                TreeData = data.children;
            } 
            if(data.libraryData != null){
                //遍历节点下的点，和节点一起展示
                for(var a = 0; a<data.libraryData.length; a++){
                    if(TreeData.indexOf(data.libraryData[a])==-1){
                        data.libraryData[a].title = data.libraryData[a].name+".PV";
                        data.libraryData[a].children = [];
                        TreeData.push(data.libraryData[a]);
                    }
                }
            }
            this.tagsTreeData = TreeData;
        },
        //关闭
        onClose(){
            this.isShow = false;
            if(typeof this.resolve == "function"){
                this.resolve({
                    name : this.getData,
                    desc : this.getDesc
                    });
            }else{
                return {
                    name : this.getData,
                    desc : this.getDesc
                };
            }
        },
        //点击后退
        after(){
            //获取数组中最后一个来实现后退
            this.tagsTreeData = this.parentData[this.parentData.length-1];
            if(this.parentData.length > 1){
                this.parentData.pop();//删除数组中最后一个
            }
            this.route = "";
            this.current="";
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            
            if(this.isEnable) return;
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.domStyle = {
                width : this.$el.offsetParent.offsetWidth + "px",
                height : this.$el.offsetParent.offsetHeight + "px",
                backgroundColor:"#fff",
                zIndex : 3000
            };
            if(this.fontSize){
                this.$el.style.fontSize = parseInt((12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            //使表单高度永远为自适应高度
            this.historyFormHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom) - 24);
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        // Show(isShow){
        //     this.isShow = isShow ? true : false;
        // },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /**
         * 作用：打开窗口调用 打开本窗口使用sytemApi
         */
        show : function(oldName,isMidVar,isDataSource,isLong,resolve){
            if(window.isApp()){
                //判断是否是手机，如果不是手机浏览器不打开窗口
                document.getElementsByClassName("styleApp")[0].parentNode.style.width = window.innerWidth+"px";
                document.getElementsByClassName("styleApp")[0].parentNode.style.margin = 0+"px";
                document.getElementsByClassName("styleApp")[0].parentNode.style.padding = 0+"px";
                // this.oldName = oldName;
                // this.isMidVar = isMidVar;
                // this.isDataSource = isDataSource;
                // this.isLong = isLong;
                this.isShow = true;
                this.resolve = resolve ? resolve : undefined;
                if(oldName==undefined){
                    this.tagsTreeData = this.$store.state.system.$.tagsTreeData;
                }else{
                    //需要获取字段名称来进行数据查询
                }
            }else{
                this.$Message.info('窗口是pc端禁用此方法！！！');
            }
            
            
        },
        /*
            参数：无
            作用：更新数据
        */
        UpdataData(){
            this.tagsTreeData = this.$store.state.system.$.tagsTreeData;
        }
        
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/dataDialog.vue